export const hinnastoData = {
  header: {
    title: "Musiikkiopiston hinnasto",
    subtitle: "Keskisen Uudenmaan Musiikkiopisto"
  },
  yleisetHuomautukset: [
    "Lukukausimaksu laskutetaan kotiin tai verkkopankkiin tulevalla laskulla kerran lukukaudessa, eli sekä syys- että kevätlukukaudella. Suosittelemme e-laskusopimuksen tekemistä.",
    "Opinnot jatkuvat syyslukukaudelta kevätlukukaudelle automaattisesti ilman erillistä ilmoittautumista.",
    "Lopetusilmoitus tehdään kirjallisesti osoitteeseen musiikkiopisto@jarvenpaa.fi. Opettajalle ilmoittaminen ei riitä lopetusilmoitukseksi."
  ],
  tpo: {
    id: "tpo",
    label: "Taiteen perusopetus",
    kuvaus: [
      "Taiteen perusopetuksen lukukausimaksu on kokonaismaksu, joka sisältää soittotunnin lisäksi erilaisia ryhmäopintoja, kuten muhaa (musiikin hahmotusaineita) ja yhteismusisointia (orkesteri, kuoro, bändi, musiikkileikkikoulu, musiikkivalmennus jne.).",
      "Laulu-/soitinvalmennus ja musikanttiopetus eivät sisälly taiteen perusopetuksen lukukausimaksuun.",
      "Soittotunnin kesto on yleensä 45 minuuttia. 30 minuutin tunti on tarkoitettu nuorimmille oppilaille opintojen alussa. 60-minuuttisiin tunteihin siirrytään tasokonsertti 3:n suorittamisen jälkeen."
    ],
    alennus: "Taiteen perusopetuksen oppilaille (sis. myös musiikkileikkikoulu ja musiikkivalmennus) myönnetään 50% alennus pääaineen lukukausimaksuun perheen kolmannesta lapsesta alkaen. Sisarusalennusta ei myönnetä avoimen puolen opetukseen eikä koulumusikanttiopetukseen.",
    hinnat: [
      { nimi: "Musiikin perusopetus, pääaine 30 min", hinta: "320 €" },
      { nimi: "Musiikin perusopetus, pääaine 45 min", hinta: "350 €" },
      { nimi: "Musiikin perusopetus, pääaine 60 min", hinta: "375 €" },
      { nimi: "Sivuaine 30 min", hinta: "320 €" },
      { nimi: "Sivuaine 45 min", hinta: "350 €" },
      { nimi: "Soitinvuokra / lukukausi", hinta: "75 €" },
      { nimi: "Kirjaamismaksu, perusopetuksen uudet oppilaat", hinta: "15 €" },
      { nimi: "Peruutusmaksu, perusopetus", hinta: "50 €" },
      { nimi: "Materiaalimaksu (TPO) / lukukausi", hinta: "2,50 €" }
    ],
    peruutusehdot: {
      uudet: [
        "Kirjaamismaksu 15 € koskee kaikkia taiteen perusopetuksessa aloittavia oppilaita.",
        "Jos opinnot perutaan kahden opintokerran jälkeen, veloitetaan peruutusmaksu 50 €.",
        "Kolmen opintokerran jälkeen lopettavalta peritään 50 % lukukausimaksusta.",
        "Viidennestä opintokerrasta alkaen veloitetaan koko lukukausimaksu. Huomioithan, että myös oppilaan poissaolokerta on pidetty opetuskerta."
      ],
      jatkavat: [
        "Lukukauden vaihteessa opinnot voi perua maksutta ilmoittamalla tulevan lukukauden peruutuksesta toimistoon viimeistään 1.8. / 1.12. mennessä.",
        "Tämän jälkeen peruutetuista opinnoista veloitetaan peruutusmaksu 50 €.",
        "Kolmen opintokerran jälkeen lopetuksesta peritään 50 % lukukausimaksusta.",
        "Viidennestä opintokerrasta alkaen veloitetaan koko lukukausimaksu. Huomioithan, että myös oppilaan poissaolokerta on pidetty opetuskerta."
      ]
    }
  },
  muskari: {
    id: "muskari",
    label: "Varhaisiän musiikkikasvatus",
    kuvaus: "Tervetuloa kokeilemaan ensimmäinen kerta maksutta!",
    hinnat: [
      { nimi: "Musiikkileikkikoulu, 45 min", hinta: "125 €" },
      { nimi: "Musiikkileikkikoulu, 60 min", hinta: "145 €" },
      { nimi: "Musiikkivalmennus, 60 min", hinta: "145 €" },
      { nimi: "Laulu- / soitinvalmennus", hinta: "205 €" },
      { nimi: "Peruutusmaksu, varhaisiän musiikkikasvatus", hinta: "20 €" }
    ],
    lisatiedot: [
      "50% alennus kolmannesta sisaruksesta alkaen.",
      "Yksilöopetuksen oppilaille osallistuminen musiikkileikkikouluun ja musiikkivalmennukseen sisältyy lukukausimaksuun, eikä niistä veloiteta erikseen.",
      "Musikantit ja koulumusikantit voivat osallistua musiikkileikkikoulu- ja musiikkivalmennusryhmiin puoleen hintaan.",
      "Laulu-/soitinvalmennus ei sisälly muihin lukukausimaksuihin."
    ],
    peruutusehdot: {
      yleiset: [
        "Ensimmäinen tutustumiskerta on maksuton.",
        "Jos lopetusilmoitus tehdään viimeistään kahden opintokerran jälkeen, peritään voimassa olevan hinnaston mukainen peruutusmaksu (20 €).",
        "Kolmannen opintokerran jälkeen lopettavalta peritään 50% lukukausimaksusta.",
        "Viidennestä opintokerrasta alkaen veloitetaan koko lukukausimaksu. Huomioithan, että myös oppilaan poissaolokerta on pidetty opetuskerta.",
        "Opinnot jatkuvat syyslukukaudelta kevätlukukaudelle automaattisesti ilman erillistä ilmoittautumista.",
        "Jos oppilas haluaa perua kevätlukukauden, tulee se tehdä 1.12. mennessä. Tämän jälkeen tehdyistä peruutuksista peritään hinnaston mukainen peruutusmaksu (20 €)."
      ]
    }
  },
  avoin: {
    id: "avoin",
    label: "Avoin musiikkiopisto",
    kuvaus: "Avoimeen musiikkiopistoon on jatkuva ilmoittautuminen. Opetukseen ei ole ikä- tai kotikuntarajoituksia. Oppilaat valitaan ilmoittautumisjärjestyksessä vapaille oppilaspaikoille.",
    huomautus: "HUOM! Opinnot jatkuvat syyslukukaudelta kevätlukukaudelle automaattisesti ilman erillistä ilmoittautumista.",
    hinnat: [
      { nimi: "Yksilöopetus 10x (20/30/45/60 min)", hinta: "238/ 355/ 474/ 589 €" },
      { nimi: "Yksilöopetus 15x (20/30/45/60 min)", hinta: "355/ 474/ 662/ 882 €" },
      { nimi: "Soitinvuokra / lukukausi", hinta: "75 €" },
      { nimi: "Musikantit / Koulumusikantit (pari-/ pienryhmäopetus) 10 x", hinta: "140 €" },
      { nimi: "Musikantit / Koulumusikantit soitinvuokra / lukukausi", hinta: "25 €" },
      { nimi: "Musiikin hahmotusaineet ainoana opintona", hinta: "75 €" },
      { nimi: "Kuoro/orkesteri/yhtye ainoana opintona", hinta: "75 €" }
    ],
    lisatiedot: [
      "Yksilöopetuksen oppilaille osallistuminen ryhmäopetukseen (musiikin hahmotusaineet, orkesteri, kuoro, bändi, musiikkileikkikoulu, musiikkivalmennus jne.) sisältyy lukukausimaksuun, eikä niistä veloiteta erikseen.",
      "Musikantit ja koulumusikantit voivat osallistua musiikkileikkikoulu- ja musiikkivalmennusryhmiin puoleen hintaan.",
      "Kuoroihin, orkestereihin ja musiikin hahmotusaineiden ryhmiin osallistuminen on maksutonta muiden opintojen ohella."
    ],
    peruutusehdot: {
      yleiset: [
        "Jos opinnot lopettaa ennen lukukausimaksujen lähettämistä, maksetaan vain pidetyistä tunneista.",
        "Mikäli lukukausimaksut on jo lähetetty, laskua ei hyvitetä.",
        "Koulumusikantit laskutetaan jaksoissa kerran lukukaudessa, ja yksi jakso sisältää 10 opetuskertaa. Maksu veloitetaan voimassa olevan hinnaston mukaan, vaikka harrastus lopetetaan kesken jakson.",
        "Huomioithan, että myös oppilaan poissaolokerta on pidetty opetuskerta."
      ]
    }
  },
  muu: {
    id: "muu",
    label: "Muu opetus & muuta",
    hinnat: [
      { nimi: "Soitinkokeilu 4 x 30 min", hinta: "120 €" },
      { nimi: "Soitinkokeilu 4 x 30 min, 2 hengen ryhmä", hinta: "90 €" },
      { nimi: "Soitinkokeilun soitinvuokra", hinta: "25 €" },
      { nimi: "Viikonloppukurssi 4t", hinta: "50 €" },
      { nimi: "Viikonloppukurssi 8t", hinta: "100 €" },
      { nimi: "Kesämuskari", hinta: "60 €" },
      { nimi: "Ulkopuoliset tasosuoritukset", hinta: "180 €" },
      { nimi: "Soitinvuokra, ulkopuoliset / lukukausi", hinta: "250 €" }
    ],
    lisatiedot: [
      "Soitinkokeiluja järjestetään pääsääntöisesti kevätlukukaudella soittimissa, joiden opettajilla on aikataulussaan tilaa kokeilulle."
    ]
  },
  poikkeustilanteet: [
    {
      otsikko: "Maksuhuojennukset",
      sisalto: [
        "Taiteen perusopetuksen oppilaalle voidaan myöntää maksuhuojennusta (60/100%) pääaineen lukukausimaksusta taloudellisilla perusteilla lukukaudeksi kerrallaan.",
        "Maksuhuojennusta haetaan Eepoksen kautta syys- ja kevätlukukauden alussa. Liitteinä toimitetaan viimeisin verotuspäätös sekä hakijaa/hakijoita koskevat tukipäätökset (esim. päätös toimeentulotuesta, työttömyyspäivärahasta tms.). Liitteet toimitetaan kaikilta huoltajilta tai samassa taloudessa asuvilta aikuisilta.",
        "Maksuhuojennus voidaan myöntää yhden hakemuksen perusteella kaikille samaan perheeseen tai ruokakuntaan kuuluville taiteen perusopetuksen oppilaille.",
        "Maksuhuojennuksia ei voida myöntää kesken lukukauden eikä avoimeen tai koulumusikanttiopetukseen."
      ]
    },
    {
      otsikko: "Opintojen keskeyttäminen",
      sisalto: [
        "Opintojen keskeytys koskee vain perusopetuksen oppilaita.",
        "Rehtori voi myöntää opintojen keskeytyksen enintään vuodeksi kerrallaan perustelluista syistä, joita ovat esim. asevelvollisuuden suorittaminen, vanhempainvapaa, määräaikainen muutto tai sairaus, josta on lääkärin todistus.",
        "Anomus opintojen keskeytyksestä tehdään keväisin jatkoilmoittautumislomakkeella tai lukuvuoden aikana sähköpostitse musiikkiopiston toimistoon musiikkiopisto@jarvenpaa.fi."
      ],
      alaosio: {
        otsikko: "Sairastuminen",
        teksti: "Poissaolot sairastumisen vuoksi voidaan hyvittää lääkärintodistusta vastaan. Omavastuu sairasloman ajalta on yksi kuukausi. Laskua ei hyvitetä sen eräpäivän jälkeen."
      }
    }
  ]
};